// Typelizer digest 0a529c35321c17e7822cdcfee4d2323b
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** POST /api/user_project_roles/:id/update_role */
  updateRole: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/api/user_project_roles/:id/update_role', params, options),
    method: 'post',
  }),

  /** POST /api/user_project_roles/:id/toggle_blocked */
  toggleBlocked: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/api/user_project_roles/:id/toggle_blocked', params, options),
    method: 'post',
  }),

  /** GET /api/user_project_roles */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/api/user_project_roles', {}, options),
    method: 'get',
  }),
}
